module.exports = __webpack_public_path__ + "img/59029ae.png";